import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreventScrollDirective } from './prevent-scroll.directive';



@NgModule({
  declarations: [
    PreventScrollDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PreventScrollDirective
  ]
})
export class DirectivesModule { }
